export class NumberConfigurations {
  static readonly SESSION_IS_OVER_REDIRECT_TIME_IN_SECONDS = 10;
}
